import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getSearchMyBookingCustomerRequestsCount } from "app/pages/Account/SearchMyBooking/searchMyBookingSelector";
import AccountAsideMenuUnauthenticated from "app/pages/Account/AccountAsideMenu/AccountAsideMenuUnauthenticated";

const AccountAsideMenuUnauthenticatedContainer = ({
	customerRequestsCount = 0,
	onItemClick = () => {},
	myBooking = {},
}) => {
	return (
		<AccountAsideMenuUnauthenticated
			onItemClick={onItemClick}
			showCustomerRequestNotification={customerRequestsCount > 0}
			myBooking={myBooking}
		/>
	);
};

AccountAsideMenuUnauthenticatedContainer.propTypes = {
	customerRequestsCount: PropTypes.number,
	onItemClick: PropTypes.func,
	myBooking: PropTypes.object,
};

const mapStateToProps = state => {
	return {
		customerRequestsCount: getSearchMyBookingCustomerRequestsCount(state),
		myBooking: state.searchMyBooking.booking,
	};
};

export default connect(mapStateToProps)(AccountAsideMenuUnauthenticatedContainer);
